import styled, { css } from 'styled-components';
import { textOverflow } from 'helpers/styles.js';
import sharedIcon from 'images/icons/shared-amongst.svg';
import { StyledBadgeContainer } from 'components/Global/Badges/styled.js';
import { StyledTag } from 'components/Global/Tag/styled.js';

export const Name = styled.div`
  font-size: 14px;
  line-height: 22px;
  align-items: center;
  color: #323848;
  text-overflow: ellipsis;
  width: 60%;
  white-space: nowrap;
  overflow: hidden;
  padding-top: 10px;
  margin-left: 70px;
  @media(max-width: 1300px) {
    max-width: 40%;
  }
`;

export const Logo = styled.div`
  vertical-align: middle;
  background-image: ${({ logo_url }) => `url('${logo_url}')`};
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background-color: white;
  float: left;
  margin: 0 4px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
`;

export const Badge = styled.div`
  width: 21px;
  height: 21px;
  text-align: center;
  background: white;
  font-size: 10px;
  color: #2D8BFF;
  bottom: -8px;
  right: -4px;
  position: absolute;
  border-radius: 100%;
  overflow: hidden;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  line-height: 23px;
`;

export const SharedInfo = styled.div`
  ${textOverflow};
  border-top: 1px solid #F3F4F5;
  height: 60px;
  line-height: 60px;
  text-align: center;
  width: 80%;
  margin: auto;
  font-size: 12px;
  color: #939AAB;

  > span {
    color: #2D8BFF;
  }
`;

export const StyledSharedIcon = styled.div`
  display: inline-block;
  margin-right: 8px;
  width: 15px;
  height: 10px;
  background: url('${sharedIcon}');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  vertical-align: text-top;
`;

export const ValueContainer = styled.div`
  vertical-align: top;
  position: absolute;
  right: 31px;
  top: 40px;
`;

export const Value = styled.div`
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  text-align: right;
  color: #2D8BFF;
`;

export const ValueDesc = styled.div`
  font-weight: normal;
  font-size: 12px;
  line-height: 17px;
  text-align: right;
  color: #939AAB;
`;

export const LeaderboardContainer = styled.div`
  position: relative;
`;

export const LeaderboardSection = styled.div`
  height: 100%;
  position: relative;
  width: 33.33%;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.06);
  border-radius: 2px;
  display: inline-block;

  &:last-child {
    border: none;
  }

  ${StyledTag} > ${StyledBadgeContainer} {
    bottom: -10px;
    right: -9px;
    position: absolute;
  }

  ${({ noData, theme }) => noData && css`
    ${Name} {
      font-weight: normal;
    }
    ${Name}, ${Value}, ${Badge} {
      color: ${theme.colors.graphPalette[3]};
    }
    ${Logo}, ${StyledTag} {
      background-color: #E2E2E2;
    }
    ${StyledTag} {
      border: none;
    }
  `};

  @media(max-width: 1300px) {
    /* Targets the immediate child Box */
    > div {
      padding-left: 16px;
    }
  }
`;
